import { SvgIcon } from "@mui/material";

function PrivacyIcon(props) {
  return (
    <SvgIcon viewBox="0 0 22 27" {...props}>
      <path d="M19.399 8.31219C19.399 3.83347 15.6349 0 11 0C6.35365 0 2.60104 3.71656 2.60104 8.31219V12.4152H5.44271V8.49379C5.44271 5.44631 7.92917 2.97427 11 2.97427C14.0651 2.97427 16.5573 5.33848 16.5573 8.31219H19.399ZM1.31198 13.4764C0.469792 14.7704 0 16.2629 0 17.8349C0 22.8459 4.86979 27 11 27C17.1302 27 22 22.8459 22 17.8349C22 16.2629 21.5245 14.7704 20.688 13.4764H1.31198ZM10.9828 14.8328C12.2604 14.8328 13.326 15.8543 13.326 17.1198C13.326 18.0732 12.7188 18.8904 11.888 19.2366L13.7615 24.8094H8.23854L10.0776 19.2366C9.24687 18.8904 8.67396 18.0675 8.67396 17.1198C8.67396 15.8543 9.70521 14.8328 10.9828 14.8328Z" />
    </SvgIcon>
  );
}

export default PrivacyIcon;
